import React from 'react';

import './blog-post-skeleton.css';

export const BlogPostSkeleton = () => (
  <div
    className="blog-post-skeleton"
    aria-hidden="true"
    role="progressbar"
    aria-busy="true"
    aria-valuetext="Loading..."
    aria-label="Loading..."
  >
    <div className="blog-post-skeleton__cover-image" />

    <div className="blog-post-skeleton__category" />

    <div className="blog-post-skeleton__title" />

    <div className="blog-post-skeleton__summary">
      <div className="blog-post-skeleton__summary__row" />
      <div className="blog-post-skeleton__summary__row" />
      <div className="blog-post-skeleton__summary__row blog-post-skeleton__summary__row--half" />
    </div>
  </div>
);
